package com.anjuros.website.redesign.sections.about

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.AboutPrinciplesGridStyle
import com.anjuros.website.redesign.styles.RdFaqBandStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdIconBadgeStyle
import com.anjuros.website.redesign.styles.RdSectionStyle
import com.anjuros.website.redesign.util.RdIcons
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

private class Principle(val icon: @Composable () -> Unit, val title: RdText, val text: RdText)

private val Principles = listOf(
    Principle({ RdIcons.Code(size = 22) }, RdText.PRINCIPLE1_TITLE, RdText.PRINCIPLE1_TEXT),
    Principle({ RdIcons.GraduationCap(size = 22) }, RdText.PRINCIPLE2_TITLE, RdText.PRINCIPLE2_TEXT),
    Principle({ RdIcons.Chat(size = 22) }, RdText.PRINCIPLE3_TITLE, RdText.PRINCIPLE3_TEXT),
    Principle({ RdIcons.Briefcase(size = 22) }, RdText.PRINCIPLE4_TITLE, RdText.PRINCIPLE4_TEXT),
    Principle({ RdIcons.ShieldCheck(size = 22) }, RdText.PRINCIPLE5_TITLE, RdText.PRINCIPLE5_TEXT),
    Principle({ RdIcons.Bolt(size = 22) }, RdText.PRINCIPLE6_TITLE, RdText.PRINCIPLE6_TEXT),
)

/** "Why work with me" on the pale-blue band. */
@Composable
fun AboutPrinciplesSection() {
    RdSection(id = "why", labelledBy = "why-h", modifier = RdSectionStyle.toModifier().then(RdFaqBandStyle.toModifier())) {
        RdSectionHead(RdText.ABOUT_PRINCIPLES_EYEBROW, "why-h", RdText.ABOUT_PRINCIPLES_TITLE, RdText.ABOUT_PRINCIPLES_LEDE)
        Ul(AboutPrinciplesGridStyle.toModifier().toAttrs()) {
            Principles.forEach { principle ->
                Li {
                    Span(RdIconBadgeStyle.toModifier().toAttrs()) { principle.icon() }
                    H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(principle.title)) }
                    P { Text(LocalText(principle.text)) }
                }
            }
        }
    }
}
